import { Link } from "react-router-dom";
import { Building2, MapPin, Key, TrendingUp } from "lucide-react";

const SERVICES = [
  { i: Key, t: "Property Buying", d: "Verified residential & commercial properties across top Indian cities with home-loan pre-approval." },
  { i: Building2, t: "Property Selling", d: "Get the best market price for your property with our network of pre-qualified buyers." },
  { i: MapPin, t: "Property Rentals", d: "Furnished, semi-furnished and unfurnished rentals — verified & fair." },
  { i: TrendingUp, t: "Property Investment", d: "Advisory on plots, under-construction and pre-launch investments." },
];

export default function Property() {
  return (
    <div data-testid="property-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
      <div className="sk-badge sk-badge-gold">Property Services</div>
      <h1 className="mt-4 font-display text-5xl text-white leading-tight">Your <span className="gold italic">property partner</span></h1>
      <p className="mt-4 text-white/60 max-w-xl">Buy · Sell · Rent · Invest — end-to-end property services bundled with financing.</p>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
        {SERVICES.map((p, i) => (
          <div key={i} className="sk-card-dark p-7" data-testid={`property-${p.t.toLowerCase().replace(/\s+/g,"-")}`}>
            <div className="w-12 h-12 rounded-xl bg-[#D4AF37]/15 border border-[#D4AF37]/30 flex items-center justify-center mb-5"><p.i className="text-[#D4AF37]" size={22}/></div>
            <div className="font-display text-xl text-white">{p.t}</div>
            <p className="text-white/60 mt-2 text-sm">{p.d}</p>
          </div>
        ))}
      </div>
      <div className="mt-16 sk-card-dark p-10 text-center">
        <h2 className="font-display text-3xl text-white">Looking for a property or loan?</h2>
        <p className="text-white/60 mt-3">Our property + finance experts will help you find the perfect match.</p>
        <div className="mt-6 flex justify-center gap-3">
          <Link to="/contact" className="sk-btn-gold">Talk to us</Link>
          <Link to="/apply" className="sk-btn-ghost">Apply for property loan</Link>
        </div>
      </div>
    </div>
  );
}
